<app-header></app-header>

<div class="container-fluid section">
    <div class="row justify-content-center">
        <div class="col-11 col-sm-10 sub-section my-3 p-4">
            <span class="title">Edit profile</span>
            <form [formGroup]="profileForm">
                <div class="row justify-content-center mt-5">
                    <div class="col-sm-9 col-md-8 col-lg-7 col-xl-5">
                        <div class="d-flex flex-row">
                            <div class="image-container-before mr-4" *ngIf="!pictureUrl">
                                <img src="../../../assets/Images/mother.svg" alt="profile pic">
                            </div>
                            <img *ngIf="pictureUrl" [src]="pictureUrl" class="image-container-after mr-4" />
                            <div class="d-flex flex-column">
                                <button class="btn btn-theme-inverse mt-3 d-flex flex-row" data-toggle="modal"
                                    data-target="#image-upload" (click)="openModal('upload')">
                                    <img src="../../../assets/Images/upload-icon.svg" class="icon mr-2">
                                    <span class="icon-text"> Upload profile picture</span>
                                </button>
                                <button class="btn btn-theme-inverse mt-3 d-flex flex-row" data-toggle="modal"
                                    data-target="#image-upload" (click)="openModal('camera')">
                                    <img src="../../../assets/Images/camera-icon.svg" class="icon mr-2">
                                    <span class="icon-text"> Capture using camera</span>
                                </button>
                                <button class="btn btn-theme-inverse mt-3 d-flex flex-row" [disabled]="!pictureUrl"
                                    (click)="removeProfile()">
                                    <img src="../../../assets/Images/delete-icon.svg" class="icon mr-2">
                                    <span class="icon-text"> Delete Photo</span>
                                </button>
                            </div>
                        </div>
                        <div class="d-flex flex-column">
                            <span class="input-label mt-3 mb-1">Name</span>
                            <input class="form-control form-control-sm header-search" formControlName="name"
                                placeholder="Name">
                            <span class="input-label mt-3 mb-1">Email</span>
                            <input class="form-control form-control-sm header-search" formControlName="userEmail"
                                type="email" placeholder="Email">
                            <div class="row">
                                <div class="col-md-6 pr-md-0">
                                    <div class="d-flex flex-column">
                                        <span class="input-label mt-3 mb-1">Country code</span>
                                        <mat-form-field class="w-100">
                                            <mat-select formControlName="countryCode" name="country code mum"
                                                id="country-code-mum">
                                                <mat-option *ngFor="let country of countries"
                                                    [value]="country.dial_code">
                                                    <img class="dropdown-profile-img"
                                                        [src]="country.flag">{{country.name}}
                                                    <span class="text-muted">({{country.dial_code}})</span>
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="d-flex flex-column">
                                        <span class="input-label mt-3 mb-1">Phone</span>
                                        <input class="form-control form-control-sm header-search"
                                            formControlName="userPhonenumber" type="tel" placeholder="Phone">
                                    </div>
                                </div>
                            </div>
                            <span class="input-label mt-3 mb-1">Area</span>
                            <mat-form-field class="w-100">
                                <mat-select formControlName="area" name="area" id="area">
                                    <mat-option [value]="area.name" *ngFor="let area of areas">{{area.name}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                            <span class="input-label mt-3 mb-1">Address</span>
                            <mat-form-field class="w-100" appearance="fill">
                                <input type="text" placeholder="Search Area" matInput [formControl]="myControl"
                                    [matAutocomplete]="auto">
                                <mat-autocomplete #auto="matAutocomplete"
                                    (optionSelected)='selectArea($event.option.value)'>
                                    <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
                                        {{option}}
                                    </mat-option>
                                </mat-autocomplete>
                            </mat-form-field>
                            <div class="row">
                                <div class="col-md-6 pr-md-0">
                                    <div class="d-flex flex-column">
                                        <span class="input-label mt-3 mb-1">Age</span>
                                        <input class="form-control form-control-sm header-search" formControlName="age"
                                            type="number" placeholder="Age" min="15">
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="d-flex flex-column">
                                        <span class="input-label mt-3 mb-1">Due Date</span>
                                        <mat-form-field class="w-100">
                                            <input class="form-control form-control-sm header-search" matInput
                                                [matDatepicker]="picker" [min]="minDate" formControlName="dueDate"
                                                name="dueDate" required>
                                            <mat-datepicker-toggle id="due-date-picker" matSuffix [for]="picker">
                                            </mat-datepicker-toggle>
                                            <mat-datepicker #picker></mat-datepicker>
                                        </mat-form-field>
                                    </div>
                                </div>
                            </div>
                            <span class="input-label mt-3 mb-1">Password</span>
                            <div class="input-icons">
                                <i class="fas eye-icon" [ngClass]="{'fa-eye': eye, 'fa-eye-slash': !eye}"
                                    (click)="toggle('midwife')"></i>
                                <input #pass class="form-control form-control-sm header-search"
                                    formControlName="newPassword" placeholder="Password" type="password">
                            </div>
                        </div>
                        <div class="horizontal-line my-4"></div>
                        <div class="d-flex flex-row justify-content-end">
                            <button class="btn btn-cancel mr-2" [routerLink]="['/dashboard']">Cancel</button>
                            <button class="btn btn-theme" (click)="updateProfile()" [disabled]="!profileForm.valid">
                                <div class="d-flex flex-row justify-content-center">
                                    <div class="spinner-border loader" role="status" *ngIf="loading">
                                        <span class="sr-only">Loading...</span>
                                    </div>
                                    <span class="align-self-center" *ngIf="!loading">Save</span>
                                </div>
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>

<!-- Image Upload Modal Starts-->
<app-image-upload (profilePic)="setProfile($event)" [aspectRatio]="1 / 1" [mode]="'profile pic'"></app-image-upload>
<!-- Image Upload Modal Ends-->